var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFa6SolidChartLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_1582_7540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.50004 3C3.50004 2.17031 2.82973 1.5 2.00004 1.5C1.17035 1.5 0.500038 2.17031 0.500038 3V18.75C0.500038 20.8219 2.17816 22.5 4.25004 22.5H23C23.8297 22.5 24.5 21.8297 24.5 21C24.5 20.1703 23.8297 19.5 23 19.5H4.25004C3.83754 19.5 3.50004 19.1625 3.50004 18.75V3ZM22.5594 7.05938C23.1454 6.47344 23.1454 5.52188 22.5594 4.93594C21.9735 4.35 21.0219 4.35 20.436 4.93594L15.5 9.87656L12.8094 7.18594C12.2235 6.6 11.2719 6.6 10.686 7.18594L5.43598 12.4359C4.85004 13.0219 4.85004 13.9734 5.43598 14.5594C6.02191 15.1453 6.97348 15.1453 7.55941 14.5594L11.75 10.3734L14.4407 13.0641C15.0266 13.65 15.9782 13.65 16.5641 13.0641L22.5641 7.06406L22.5594 7.05938Z",
    fill: "#16839A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1582_7540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFa6SolidChartLine);
export default __webpack_public_path__ + "static/media/fa6-solid_chart-line.61d0f74378489503e788883a6aea618e.svg";
export { ForwardRef as ReactComponent };